module.exports = __webpack_public_path__ + "applause.ba25a547.png";